import dayjs from "@/lib/dayjs";

import { getTodaysDate } from "../get-todays-date";

/**
 * 操作日以前かどうか（過去の日付かどうか）
 */
export function isPastDate(date: string): boolean {
	const today = getTodaysDate();
	return dayjs(date).isBefore(today, "date");
}
